import { AsyncSubject } from 'rxjs';


const segmentsAsyncs: any = {
  itemDetails: new AsyncSubject<any>(),
  description: new AsyncSubject<any>(),
  attributes: new AsyncSubject<any>(),
  packaging: new AsyncSubject<any>(),
  pricing: new AsyncSubject<any>(),
  digitalAssets: new AsyncSubject<any>(),
  fitments: new AsyncSubject<any>(),
  kits: new AsyncSubject<any>(),
  interchange: new AsyncSubject<any>(),
  marketing: new AsyncSubject<any>(),
};

export default segmentsAsyncs;
